import React, { Suspense, lazy } from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import SessionTimeout from 'components/SessionTimeout';
import { WithOneTabEnforcer } from 'components/SecurityFeatures/WithOneTabEnforcer';
import OneTabAuth from 'components/SecurityFeatures/OneTabAuth';
import { security } from 'config/securityFeatures';

// Top navigation (grouped menus + Cmd/Ctrl+K quick search) replaces the old header + sidebar.
const TopNav = lazy(() => import('components/TopNav'));
const Content = lazy(() => import('./component/Content'));

const PageSkeleton = () => (
  <div className="rb-skeleton" aria-busy="true" aria-label="Loading">
    <div className="rb-skeleton-line w-25" />
    <div className="rb-skeleton-line w-50" />
    <div className="rb-skeleton-block" />
  </div>
);

const App = () => (
  <>
    <ErrorBoundary>
      <SessionTimeout />
      <Suspense fallback={<div className="rb-topbar" />}>
        <TopNav />
      </Suspense>
    </ErrorBoundary>
    <main className="rb-main">
      <div className="rb-page">
        <ErrorBoundary>
          <Suspense fallback={<PageSkeleton />}>
            <Content />
          </Suspense>
        </ErrorBoundary>
      </div>
    </main>
  </>
);

const appHolder = security.enableTabEnforcerSecurity
  ? WithOneTabEnforcer()(OneTabAuth(App))
  : App;
export default appHolder;
